import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from '../../components/constant';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import moment from 'moment';
import { getAllOnlineVendor } from '../../dropdowns';
import { useGetCollectPaymentContext } from '../../../context';
import Error from '../../errorHandlimg/Error';
import { onlineValidation } from '../../validations/paymentModeValidation';
import { getTermDate } from '../../../apis';
import { getConditionalCOllectSaveButton } from '../../components/common';

const OPModeView =({ isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose}) =>{
    const [errorMgs,setErrorMgs] = useState('')

      const {
        bankDropdown,
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setModifyPaymentModeData,
        validatePaymentMode,
        disableAmountField
    } = contextValue;

      const [onlineSaleDropdown,setOnlineSaleDropdown]=useState([{}])
    //   const [termStartDate,setTermStartDate] = useState()
      useEffect(()=>{
        const getDropdown = async () => {
            setloader(true);
            const data=await Promise.all([getAllOnlineVendor()])
            setOnlineSaleDropdown(data[0]);
            //setTermStartDate(data[1])
            setloader(false)
        }
       !isView && getDropdown();
    
      },[])
      const validatePayment=async()=>{
        const error=await onlineValidation(paymentModeForm,collectPayment,balanceAmount)
        setErrorMgs(error)
        if(!error)
            {
               const isOk= await validatePaymentMode(studentBasicDetails,currentPaymentMode,paymentModeForm,selectedChargesAmount,bankMasterId,'',setBalanceAmount,setBalanceMode,setloader,setCollectPayment,balanceAmount,collectPayment)
               if(isOk){
                isReceiptEdit===true&&setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit&& handleClose(true)
               }
    
            }  
}
const disabled=!(paymentModeForm?.referenceNumber && paymentModeForm?.paidAmount && paymentModeForm?.paymentModeDate && paymentModeForm?.bank && paymentModeForm?.onlineSale)
    return(
        <>
        {!isView &&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">Online payment details</span>
        </div>}
        <Row>
        <Col md="4">
            <div>
                <AInput
                    label="Transaction ID*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.referenceNumber}
                    handler={(value) => {paymentModeFormHandler("referenceNumber",value) }}
                    placeholder="Enter"
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={isView}
                    maxLength={30}
                />
            </div>
        </Col>
        <Col md="4">
            <div>
                <AInput
                    label="Total  Amount*"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.paidAmount}
                    customIcon={
                        <div className='large-semi-bold'>&#8377;</div>
                      }
                      customIconStyle={customStyle}
                    handler={(value) => {
                        if (
                            !value || parseFloat(value) > 0
                        ) {
                            paymentModeFormHandler('paidAmount', value)
                        }

                    }}
                    placeholder="Enter amount"
                    style={inputAmountStyle}
                    disabled={isView || isReceiptEdit===true || disableAmountField}
                    regex={numberDecimalLimitRegex(10, 2)}
                />
            </div>
        </Col>
        <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Transaction date*"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => {paymentModeFormHandler("paymentModeDate",date )}}
                            isStartDate={true}
                            minDate={studentBasicDetails?.detailsMap?.termStartDate?moment(studentBasicDetails?.detailsMap?.termStartDate):''}
                            maxDate={new moment(new Date())}
                            disabled={isView}
                        />
                    </div>
                </Col>
        </Row>
        <Row>
        <Col md="4">
                    <div>
                        <AAutoComplete
                            label="Bank Id*"
                            labelStyle={labelSyle}
                            placeholder="Select bank"
                            currentValue={paymentModeForm?.bank}
                            handleChange={(value) => {paymentModeFormHandler("bank",value) }}
                            items={bankDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isDisabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                <div>
                <AInput
                    label="PayU gateway"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.gatewayName}
                    handler={(value) => {paymentModeFormHandler("gatewayName",value) }}
                    placeholder="Enter"
                    style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                    disabled={isView}
                />
                </div>
                </Col>
                <Col md="4">
            <div>
            <div>
                        <AAutoComplete
                            label="Online sale*"
                            labelStyle={labelSyle}
                            placeholder="Select online sale"
                            currentValue={paymentModeForm?.onlineSale}
                            handleChange={(value) => {paymentModeFormHandler("onlineSale",value) }}
                            items={onlineSaleDropdown}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: { height: "47px", width: '265px', borderRadius: "5px" } }}
                            isDisabled={isView}
                        />
                    </div>
            </div>
        </Col>
        </Row>
        {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
        <Error errorMgs={errorMgs}/>
        </>
        
    )
}
export default OPModeView